import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { styled } from "@twilio-paste/styling-library";
import React from "react";

export interface PProps {
    variant?: "default" | "lead";
}
export const P: React.FC<PProps> = ({ children, variant }) => (
    <Text
        as="p"
        marginBottom="space20"
        lineHeight={variant === "lead" ? "lineHeight40" : "lineHeight30"}
        fontSize={variant === "lead" ? "fontSize40" : undefined}
    >
        {children}
    </Text>
);

export const Pre: React.FC = (props) => (
    <Text as="pre" fontSize="fontSize20" marginBottom="space70" lineHeight="lineHeight30">
        {props.children}
    </Text>
);

export const InlineCode: React.FC = (props) => (
    <Box
        as="code"
        backgroundColor="colorBackground"
        borderRadius="borderRadius20"
        color="colorText"
        fontFamily="fontFamilyCode"
        fontSize="fontSize20"
        lineHeight="lineHeight20"
        paddingY="space20"
        paddingX="space30"
        {...props}
    />
);

// This mimics the style of native code html elements styled in code.css -- please ensure styling is in sync
export const Code = styled(Text)<{ bold?: { bold: boolean } }>`
    box-sizing: border-box;
    background-color: rgb(244, 244, 246);
    border: 1px solid rgb(225, 227, 234);
    border-radius: 4px;
    color: inherit;
    font-family: "Fira Mono", "Courier New", Courier, monospace;
    font-size: 0.75rem;
    line-height: 1.25rem;
    padding: 0.125rem 0.25rem;
    ${(props) => (props.bold?.bold ? "font-weight: bold;" : "")}
`;
